import { useAuth } from '@hb/react'
import { useMemo } from 'react'

export const useUnsignedConsentForms = () => {
  const { user } = useAuth()
  // const { data } = usePatientConsentForms(user?.id)
  return useMemo(
    () =>
      Object.entries(user?.consentFormsStatus ?? {})
        .filter(([, doc]) => !doc.signedOn)
        .map(([id, doc]) => ({
          id,
          ...doc,
        })),
    [user?.consentFormsStatus],
  )
}
